import React, {useCallback, useContext, useMemo, useState} from 'react';
import * as PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor/visibility-sensor';

import { classes } from 'as-ui-kit/utils/styles';

import styles from '../styles.modules.scss';
import LockedFirmInfo from '../../LockedFirmInfo';
import { DataContext, FeedbackContext } from 'contexts';
import FirmGraph from '../../FirmGraph';
import FirmCard from './FirmCard';
import ActualTrucks from '../../ActualTrucks';
import TopFirmPopover from './TopFirmPopover';
import Checkbox from '@components/checkbox';

const TableRow = ({num, value, onChangeVisibility}) => {
    const { icons, searchResults, handleSearchResultSelection, isUser } = useContext(DataContext);
    const [isVisible, setIsVisible] = useState(false);
    const [initFeedbackText, setInitFeedbackText] = useState('');
    const [feedbackFormVisible, setFeedbackFormVisible] = useState(false);
    const [feedbackWasSent, setFeedbackWasSent] = useState(false);

    const {topFirmsCount, searchId} = useMemo(() => ({
        topFirmsCount: searchResults?.result?.filter(r => r.firmTopType > 0).length || 0,
        searchId: searchResults?.searchId || ''
    }), [searchResults]);

    const isSpecialRow = useMemo(() => num === 1 && !value.id, [num, value]);

    const handleChange = (visible) => {
        if (value.id && !isVisible && visible) {
            setIsVisible(true);
            onChangeVisibility(value.id);
        }
    };

    const feedback = useMemo(() => (
        {
            feedbackFormVisible, setFeedbackFormVisible,
            initFeedbackText, setInitFeedbackText,
            feedbackWasSent, setFeedbackWasSent,
            position: num, firm: value, searchId, topFirmsCount
        }
    ), [feedbackFormVisible, initFeedbackText, feedbackWasSent, num, value, searchId, topFirmsCount]);

    return (
        <div className={classes(styles['row'], (isSpecialRow && styles['special-row']))}>
            <VisibilitySensor onChange={handleChange}>
                <FeedbackContext.Provider value={feedback}>
                    {!value.visibleNumber && (<div className={styles['top-firm-line']}/>)}
                    <div className={classes(styles['column'], styles['col_1'])}>
	                    <Checkbox
		                    checked={value.isSelected}
		                    className={styles['checkbox']}
	                        disabled={!isUser || !value.id}
		                    size="small"
		                    onChange={event => handleSearchResultSelection(value.id, event.target.checked)}
	                    />
                        {!value.visibleNumber ? (
                            <TopFirmPopover
                                position={num}
                                targetFirm={value}
                            />
                        ) : (
                            <span>
                                {value.visibleNumber}
                            </span>
                        )}
                    </div>
                    <div className={classes(styles['column'], styles['col_2'])}>
                        {value.id?
                            (
                                <FirmCard
                                    firm={value.firmInfo}
                                    icons={icons?.[value?.id]}
                                    id={value.id}
                                />
                            ): (
                                <LockedFirmInfo
                                    isFirst={num === 1}
                                />
                            )}
                    </div>
                    <div className={classes(styles['column'], styles['col_3'])}>
                        <ActualTrucks
                            atiId={value.id}
                            trucksCount={value.actualTrucksCount}
                        />
                    </div>
                    <div className={classes(styles['column'], styles['col_4'])}>
                        {value.trucksCount}
                        <FirmGraph
                            graphWidth={value.graph.width}
                            trucksWidth={value.graph.truckWidth}
                        />
                    </div>
                    <div className={classes(styles['column'], styles['col_5'])}>
                        {value.searchCount}
                    </div>
                </FeedbackContext.Provider>
            </VisibilitySensor>
        </div>
    );
};

export default TableRow;

TableRow.propTypes = {
    num: PropTypes.number,
    value: PropTypes.object,
    onChangeVisibility: PropTypes.func,
};
